import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { SVG, Rect } from '@wordpress/primitives';
var queryPagination = createElement(SVG, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, createElement(Rect, {
  x: "4",
  y: "10.5",
  width: "6",
  height: "3",
  rx: "1.5",
  fill: "#000"
}), createElement(Rect, {
  x: "12",
  y: "10.5",
  width: "3",
  height: "3",
  rx: "1.5",
  fill: "#000"
}), createElement(Rect, {
  x: "17",
  y: "10.5",
  width: "3",
  height: "3",
  rx: "1.5",
  fill: "#000"
}));
export default queryPagination;
//# sourceMappingURL=query-pagination.js.map